module.exports = __webpack_public_path__ + "static/img/e576b4914b91c725c922ae68d47b0db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon4.jpg
// module id = fE7t
// module chunks = 1